import { useState } from "react";
import Tooltip from "@shared/v2/Tooltip";
import IconButton from "@shared/v2/IconButton";
import { Check, CircleDollarRegularV6 } from "@shared/v2/Icomoon";
import { useCurrentUser, useFeatureFlags } from "../../reducers/layoutReducer/selectors";
import ReferFriendModal from "./ReferFriend/ReferFriendModal";
import DismissibleAlert from "@shared/DismissibleAlert";

const ReferAFriend = () => {
  const featureFlags = useFeatureFlags() as { referralRock: boolean };
  const {
    account: { isPlace, isLever },
  } = useCurrentUser() as { account: { isPlace: boolean; isLever: boolean } };
  const [isModalOpen, setModalOpen] = useState(false);
  const [isReferred, setReferred] = useState(false);

  const onClose = () => setModalOpen(false);
  const showModal = () => setModalOpen(true);

  const onReferred = () => {
    setReferred(true);
    setModalOpen(false);
  };
  const handleDismissAlert = () => setReferred(false);

  return (
    <>
      <Tooltip
        // @ts-expect-error props
        innerClassName="!tw-bg-neutral-gray-75"
        arrowClassName="tw-fill-neutral-gray-75"
        trigger={
          // @ts-expect-error props
          <IconButton
            aria-label="Refer a Friend"
            className={`${isPlace || isLever ? "tw-text-white" : ""}  hover:tw-bg-gray/20 active:tw-bg-gray/30`}
            onClick={() => {
              if (featureFlags.referralRock) window.location.assign("/agent_stats?report_tab=referrals");
              else showModal();
            }}
            schema="transparent"
          >
            <CircleDollarRegularV6 size="xxl" />
          </IconButton>
        }
        content="Refer a Friend"
        placement="bottom"
      />
      <ReferFriendModal isModalOpen={isModalOpen} onHideHandlr={onClose} onSave={onReferred} />
      <div className="tw-fixed tw-right-[42%] tw-left-[37%]">
        <DismissibleAlert
          variant="success"
          content={
            <p className="tw-w-[254px]">
              <Check size="xl" className="tw-mb-[-4px]" />{" "}
              <span className="tw-pl-[9px]">Referral submitted successfully.</span>
            </p>
          }
          displayAlert={isReferred}
          handleDismissAlert={handleDismissAlert}
        />
      </div>
    </>
  );
};

export default ReferAFriend;
